import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, ScrollRestoration } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
// Pages
import { HomePage } from './pages/HomePage';
import { CatalogPage } from './pages/CatalogPage';
import { CategoryPage } from './pages/CategoryPage';
import { ProductPage } from './pages/ProductPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { DeliveryPage } from './pages/DeliveryPage';
import { WarrantyPage } from './pages/WarrantyPage';
import { InstallationPage } from './pages/InstallationPage';
import { AboutPage } from './pages/AboutPage';
import { ContactsPage } from './pages/ContactsPage';
import { FAQPage } from './pages/FAQPage';
import { BlogPage } from './pages/BlogPage';
// ScrollToTop component to handle scroll restoration manually if needed
function ScrollToTop() {
  const {
    pathname
  } = React.useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
// Wrapper for ScrollToTop to use useLocation
import { useLocation } from 'react-router-dom';
export function App() {
  return <CartProvider data-id="element-0">
      <Router data-id="element-1">
        <ScrollToTopWrapper data-id="element-2" />
        <div className="flex flex-col min-h-screen" data-id="element-3">
          <Header data-id="element-4" />
          <div className="flex-grow" data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<HomePage data-id="element-8" />} data-id="element-7" />
              <Route path="/catalog" element={<CatalogPage data-id="element-10" />} data-id="element-9" />
              <Route path="/category/:slug" element={<CategoryPage data-id="element-12" />} data-id="element-11" />
              <Route path="/product/:id" element={<ProductPage data-id="element-14" />} data-id="element-13" />
              <Route path="/cart" element={<CartPage data-id="element-16" />} data-id="element-15" />
              <Route path="/checkout" element={<CheckoutPage data-id="element-18" />} data-id="element-17" />
              <Route path="/thank-you" element={<ThankYouPage data-id="element-20" />} data-id="element-19" />
              <Route path="/delivery" element={<DeliveryPage data-id="element-22" />} data-id="element-21" />
              <Route path="/warranty" element={<WarrantyPage data-id="element-24" />} data-id="element-23" />
              <Route path="/installation" element={<InstallationPage data-id="element-26" />} data-id="element-25" />
              <Route path="/about" element={<AboutPage data-id="element-28" />} data-id="element-27" />
              <Route path="/contacts" element={<ContactsPage data-id="element-30" />} data-id="element-29" />
              <Route path="/faq" element={<FAQPage data-id="element-32" />} data-id="element-31" />
              <Route path="/blog" element={<BlogPage data-id="element-34" />} data-id="element-33" />
              <Route path="/blog/:id" element={<BlogPage data-id="element-36" />} data-id="element-35" />{' '}
              {/* Reusing BlogPage for detail view demo */}
              <Route path="*" element={<HomePage data-id="element-38" />} data-id="element-37" />
            </Routes>
          </div>
          <Footer data-id="element-39" />
        </div>
      </Router>
    </CartProvider>;
}
function ScrollToTopWrapper() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}